import { render } from "./NcrmIntegrationPrivacyNotice.vue?vue&type=template&id=4c9003e6"
import script from "./NcrmIntegrationPrivacyNotice.vue?vue&type=script&lang=js"
export * from "./NcrmIntegrationPrivacyNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__